// import axios from "axios";

import axiosInstance from "../config/axios.config";

// const API_BASE = "/api/outpatient";

export const getAdmissionApi = (id) =>
  axiosInstance.get(`/outpatient/admission/${id}/`);
export const updateAdmissionApi = (id, payload) =>
  axiosInstance.put(`/outpatient/admission/${id}/`, payload);
export const patchAdmissionApi = (id, payload) =>
  axiosInstance.patch(`/outpatient/admission/${id}/`, payload);

export const createCardiopulmonaryApi = (payload) =>
  axiosInstance.post(`/cardiopulmonary/`, payload);
export const getCardiopulmonaryApi = (id) =>
  axiosInstance.get(`/cardiopulmonary/${id}/`);
export const updateCardiopulmonaryApi = (id, payload) =>
  axiosInstance.put(`/cardiopulmonary/${id}/`, payload);
export const patchCardiopulmonaryApi = (id, payload) =>
  axiosInstance.patch(`/cardiopulmonary/${id}/`, payload);
export const deleteCardiopulmonaryApi = (id) =>
  axiosInstance.delete(`/cardiopulmonary/${id}/`);

export const createSessionApi = (payload) =>
  axiosInstance.post(`/create-session/`, payload);
export const getEMRApi = (patient_id, admission_id) =>
  axiosInstance.get(`/emr/${patient_id}/admission/${admission_id}/`);

export const getExercisesApi = () => axiosInstance.get(`/exercises/`);
export const createExerciseApi = (payload) =>
  axiosInstance.post(`/exercises/`, payload);
export const getExerciseApi = (id) => axiosInstance.get(`/exercises/${id}/`);
export const updateExerciseApi = (id, payload) =>
  axiosInstance.put(`/exercises/${id}/`, payload);
export const patchExerciseApi = (id, payload) =>
  axiosInstance.patch(`/exercises/${id}/`, payload);
export const deleteExerciseApi = (id) =>
  axiosInstance.delete(`/exercises/${id}/`);

export const createNeuroApi = (payload) =>
  axiosInstance.post(`/neuro/`, payload);
export const getNeuroApi = (id) => axiosInstance.get(`/neuro/${id}/`);
export const updateNeuroApi = (id, payload) =>
  axiosInstance.put(`/neuro/${id}/`, payload);
export const patchNeuroApi = (id, payload) =>
  axiosInstance.patch(`/neuro/${id}/`, payload);
export const deleteNeuroApi = (id) => axiosInstance.delete(`/neuro/${id}/`);

export const createOrthoApi = (payload) =>
  axiosInstance.post(`/ortho/`, payload);
export const getOrthoApi = (id) => axiosInstance.get(`/ortho/${id}/`);
export const updateOrthoApi = (id, payload) =>
  axiosInstance.put(`/ortho/${id}/`, payload);
export const patchOrthoApi = (id, payload) =>
  axiosInstance.patch(`/ortho/${id}/`, payload);
export const deleteOrthoApi = (id) => axiosInstance.delete(`/ortho/${id}/`);

export const getPatientExerciseApi = () =>
  axiosInstance.get(`/patient-exercise/`);
export const createPatientExerciseApi = (payload) =>
  axiosInstance.post(`/patient-exercise/`, payload);
export const getPatientExerciseByIdApi = (id) =>
  axiosInstance.get(`/patient-exercise/${id}/`);
export const updatePatientExerciseApi = (id, payload) =>
  axiosInstance.put(`/patient-exercise/${id}/`, payload);
export const patchPatientExerciseApi = (id, payload) =>
  axiosInstance.patch(`/patient-exercise/${id}/`, payload);
export const deletePatientExerciseApi = (id) =>
  axiosInstance.delete(`/patient-exercise/${id}/`);

export const getScalesApi = (admission_id) =>
  axiosInstance.get(`/outpatient/progress-scales/${admission_id}/`);
export const createScaleApi = (payload) =>
  axiosInstance.post(`/outpatient/scales/`, payload);
export const getScaleApi = (id) =>
  axiosInstance.get(`/outpatient/scales/${id}/`);
export const updateScaleApi = (id, payload) =>
  axiosInstance.put(`/outpatient/scales/${id}/`, payload);
export const patchScaleApi = (id, payload) =>
  axiosInstance.patch(`/scales/${id}/`, payload);
export const deleteScaleApi = (id) => axiosInstance.delete(`/scales/${id}/`);

export const downloadServiceApi = (service_type, service_id) =>
  axiosInstance.get(`/services/${service_type}/download/${service_id}/`);

export const getSessionsApi = () => axiosInstance.get(`/sessions/`);
export const createSessionFullApi = (payload) =>
  axiosInstance.post(`/sessions/`, payload);
export const getSessionApi = (id) => axiosInstance.get(`/sessions/${id}/`);
export const updateSessionApi = (id, payload) =>
  axiosInstance.put(`/sessions/${id}/`, payload);
export const patchSessionApi = (id, payload) =>
  axiosInstance.patch(`/sessions/${id}/`, payload);
export const deleteSessionApi = (id) =>
  axiosInstance.delete(`/sessions/${id}/`);

export const createSportsApi = (payload) =>
  axiosInstance.post(`/sports/`, payload);
export const getSportsApi = (id) => axiosInstance.get(`/sports/${id}/`);
export const updateSportsApi = (id, payload) =>
  axiosInstance.put(`/sports/${id}/`, payload);
export const patchSportsApi = (id, payload) =>
  axiosInstance.patch(`/sports/${id}/`, payload);
export const deleteSportsApi = (id) => axiosInstance.delete(`/sports/${id}/`);

export const getTherapiesApi = () => axiosInstance.get(`/therapies/`);
export const createTherapyApi = (payload) =>
  axiosInstance.post(`/therapies/`, payload);
export const getTherapyApi = (id) => axiosInstance.get(`/therapies/${id}/`);
export const updateTherapyApi = (id, payload) =>
  axiosInstance.put(`/therapies/${id}/`, payload);
export const patchTherapyApi = (id, payload) =>
  axiosInstance.patch(`/therapies/${id}/`, payload);
export const deleteTherapyApi = (id) =>
  axiosInstance.delete(`/therapies/${id}/`);

export const getUploadsApi = () => axiosInstance.get(`/uploads/`);
export const createUploadApi = (payload) =>
  axiosInstance.post(`/uploads/`, payload);
export const getUploadByIdApi = (id) => axiosInstance.get(`/uploads/${id}/`);
export const updateUploadApi = (id, payload) =>
  axiosInstance.put(`/uploads/${id}/`, payload);
export const patchUploadApi = (id, payload) =>
  axiosInstance.patch(`/uploads/${id}/`, payload);
export const deleteUploadApi = (id) => axiosInstance.delete(`/uploads/${id}/`);

export const getFoldersListApi = (admission_id) =>
  axiosInstance.get(`/outpatient/uploads/?admission_id=${admission_id}`);
export const getFolderDataApi = (folder, admission_id) => {
  if (folder) {
    return axiosInstance.get(
      `/outpatient/uploads/?folder=${encodeURIComponent(
        folder
      )}&admission_id=${admission_id}`
    );
  } else {
    return axiosInstance.get(
      `/outpatient/uploads/?admission_id=${admission_id}`
    );
  }
};
export const getRecycleBinUploadsApi = (admission_id) =>
  axiosInstance.get(
    `/outpatient/uploads/?admission_id=${admission_id}&category_type=recycle_bin`
  );
export const createFolderApi = (payload) =>
  axiosInstance.post(`/outpatient/uploads/`, payload);
export const folderUploadApi = (payload) =>
  axiosInstance.post(`/outpatient/uploads/`, payload);
export const getOpServices = (admission_id) =>
  axiosInstance.get(`/careservices/op-package-progress/${admission_id}/`);
